import { render } from "./DisabledSelect.vue?vue&type=template&id=76814e46"
import script from "./DisabledSelect.vue?vue&type=script&lang=js"
export * from "./DisabledSelect.vue?vue&type=script&lang=js"
script.render = render

export default script